<div class="side-nav-wrapper" [class.show]="showSideNav" [class.hide]="!showSideNav">
  <div class="sn-inner-wrapper">
    <div class="sn-header">
      <div class="snh-inner-wrapper">
        <div class="logo-wrapper">
          <img src="assets/images/avenir-energy-logo-primary.svg" />
        </div>
        <div class="close">
          <span (click)="close()"><img src="assets/icons/icon-plain-close.svg" /></span>
        </div>
      </div>
    </div>
    <div class="sn-content">
      <div class="snc-inner-wrapper">
        @if (isLoggedIn) {
          <div class="menu-links">
            <!-- for logged in users only -->
            @for(menuItem of mobileLoggedInMenuItems; track $index;) {
              <div [class.btn]="menuItem.btn" [class.active-tab]="selectedTab() == $index" [attr.data-text]="menuItem.label" (click)="goToPage(menuItem.url, $event, true, $index)" class="link">{{ menuItem.label }}</div>
            }
          </div>
        }
        <div class="btn-container">
          <avenir-button [theme]="BUTTON_THEME.WHITE" [label]="contactUsLabel"
            (onClick)="openContactUsSite()">
          </avenir-button>

          <avenir-button [theme]="BUTTON_THEME.PRIMARY" [label]="orderPropaneLabel"
            (onClick)="openOrderPropaneSite()">
          </avenir-button>
        </div>
      </div>
    </div>
    <div class="sn-footer">
      <div class="snf-inner-wrapper">
        <div class="smell-propane">
          <span i18n="@@smellPropane" class="smell-propane-text">Smell Propane? </span>
          <a class="link underline" (click)="goToBranches()">
            <ng-container i18n="@@clickHere">Click Here</ng-container>
            </a>&nbsp;<span><ng-container i18n="@@forAllDaySupport">for 24/7 Support</ng-container></span>
          </div>

          <div class="menu-links menu-items-footer">
            <!-- for logged in users only -->
            @for(menuItem of bottomMenuItems; track $index;) {
              <div [class.btn]="menuItem.btn" [class.active-tab]="selectedTab() == $index" [attr.data-text]="menuItem.label" (click)="goToPage(menuItem.url, $event, true, $index)" class="link">{{ menuItem.label }}</div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>